
import { defineComponent, nextTick, onMounted, ref } from "vue";
import SysInfoPanel from "./Components/sysInfoPanel.vue";
import WorldPanel from "./Components/worldPanel.vue";
import SySMenuPanel from "./Components/sysMenuPanel.vue";
import OnlinePlyaers from "./Components/onLinePlayers.vue";
import UpdateLog from "./Components/updateLog.vue";
import { useStore } from "@/store";
import { SysInfo } from "@/const/sys";
import { SysActionTypes } from "@/store/sys/action-types";

const store = useStore();

export default defineComponent({
  components: {
    SysInfoPanel,
    WorldPanel,
    SySMenuPanel,
    OnlinePlyaers,
    UpdateLog
  },
  setup() {
    const animateIn = ref(true);
    const WorldPanel = ref();
    onMounted(() => {
      store.dispatch(
        SysActionTypes.SYS_PUSH_INFO,
        new SysInfo(`${store.state.userInfo.userName}，欢迎你，勇士！`, 3)
      );
    });
    const startBattleByData = (row: any, option: any) => {
      nextTick(() => {
        WorldPanel.value?.startBattleByData(row, option);
      });
    };
    return {
      animateIn,
      startBattleByData,
      WorldPanel
    };
  }
});
